<div class="wrapper-body" *ngIf="apptDetails">
    <div class="page-header align-items-lg-center d-flex flex-column flex-md-row">
         <h3 class="mb-4 mb-md-0">{{apptDetails.parentDetails.studentFirstName}}
            {{apptDetails.parentDetails.studentLastName}} Reschedule Follow Up</h3> 
    </div>
    <div class="row">
        <div class="col-md-6">
            <div class="card">
                <h5 class="mb-0 text-purple">Follow Up Detail</h5>
                <hr>
                <div class="row">
                    <div class="col-md-6">
                        <label class="text-grey">Location</label>
                        <p> {{apptDetails.appointmentDetails.location}}</p>
                    </div>
                    <div class="col-md-6">
                        <label class="text-grey">Director</label>
                        <p> {{apptDetails.appointmentDetails.schedules[1].adminName}}</p>
                    </div>
                    <div class="col-md-6">
                        <label class="text-grey"> Date</label>
                        <p> {{apptDetails.appointmentDetails.schedules[1].appointmentDate}}</p>
                    </div>
                    <div class="col-md-6">
                        <label class="text-grey">Time</label>
                        <p> {{apptDetails.appointmentDetails.schedules[1].appointmentTime}}</p>
                    </div>
                    <div class="col-md-6">
                        <label class="text-grey">Assessment Type</label>
                        <p> {{apptDetails.appointmentDetails.assesmentType}}</p>
                    </div>
                    <div class="col-md-6">
                        <label class="text-grey">Follow Up Types</label>
                        <p>{{apptDetails.appointmentDetails.schedules[1].meetingType}}</p>
                    </div>  
                </div>
            </div>
        </div>
        <div class="col-md-6">
            <form class="custom-form"   autocomplete="off">
                <div class="card light">
                    <h5 class="mb-0 text-purple">Reschedule Details</h5>
                    <hr>
                    <div class="row">
                        <!-- <div class="col-12" *ngIf="locations">
                             <select (change)="selectLocation()"  formControlName="locationId"
                             [(ngModel)]="locationId"  
                                id="testingLocation">
                                <option value="" selected disabled>Choose Testing Location</option>
                                <option *ngFor="let city of locations.data" [ngValue]="city.id">{{city.name}}
                                </option>
                            </select> 
                        </div> -->
                        <div class="col-12">
                            <input type="text" placeholder="Select Diagnostician"  (click)="openFollowUpModal()" 
                            autocomplete="off" name="diagnosis"   [ngModel]="resourceName" readonly>
                        </div>
                        <div class="col-12">
                            <input type="text" placeholder="Date"  name="assessmentDate"   [ngModel]="assessmentDate"  readonly >
                        </div>
                        <div class="col-12">
                            <input type="text" placeholder="Time"  name="appointmentTime"    readonly [ngModel]="appointmentTime">
                        </div>
                        <!-- <div class="col-12 my-2">
                            <button type="submit" (click)="submitForm()" class="theme-button green">Reschedule</button>
                        </div> -->
                    </div>
                </div>
            </form>
        </div>
    </div>
</div>

<div class="modal fade" id="followUpModal" data-keyboard="false" tabindex="-1" aria-labelledby="followUpModal"
    aria-hidden="true">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="actions">
                <button class="theme-button grey float-right" (click)="onDeleteClick()"
                    data-dismiss="modal">{{reset}}</button>
                <a href="javascript:void()" class="theme-button green float-right mr-2"
                   (click)="getAdminName()" data-toggle="modal" data-dismiss="modal">Save</a>
            </div>
            <div class="scheduler mt-2" *ngIf="show">
                <div class="card">
                    <mbsc-eventcalendar  [clickToCreate]="clickToCreate" [view]="view" [invalid]="invalid"
                    [data]="myEvents" [options]="calendarOptions"
                        [resources]="myResources" [resourceTemplate]="resourceTemp">
                        <ng-template #resourceTemp let-resource>
                            <div class="header-resource-template-content">
                                <!-- <img class="header-resource-avatar mb-2" [src]="resource.img" [width]="50" /> -->
                                <div class="header-resource-name">{{resource.name}}</div>
                            </div>
                        </ng-template>
                    </mbsc-eventcalendar>
                    <!--  -->
                    <mbsc-popup [options]="popupOptions" [anchor]="popupAnchor" [buttons]="popupButtons"
                        [headerText]="popupHeaderText" #popup>
                        <div class="mbsc-form-group">
                            <mbsc-input label="Title" [(ngModel)]="popupEventTitle" ></mbsc-input>                    
                            <mbsc-input label="Location" [(ngModel)]="locationName"></mbsc-input>

                        </div>
                        <div class="mbsc-form-group">
                            <mbsc-input [disabled]="true" label="Select Time Slot" labelStyle="floating"></mbsc-input>
                            <mbsc-datepicker [(ngModel)]="popupEventDates" [options]="datePickerOptions" [controls]="datetimePickerControls" [startInput]="startInput"
                            [endInput]="endInput"></mbsc-datepicker>

                        <mbsc-input #startInput label="Starts"></mbsc-input>
                        <mbsc-input #endInput label="Ends"></mbsc-input>

                            <div *ngIf="isEdit" class="mbsc-button-group">
                                <mbsc-button class="mbsc-button-block" color="danger" variant="outline"
                                    (click)="onDeleteClick()">Delete event
                                </mbsc-button>
                            </div>
                        </div>
                    </mbsc-popup>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- calender Modal -->

<!-- Follow up Confirmation Modal -->
<div class="modal fade" *ngIf="show" id="followupConfirmationModal" data-backdrop="static" data-keyboard="false"
    tabindex="-1" aria-labelledby="followupConfirmationModal" aria-hidden="true">
    <div class="modal-dialog">
        <div class="modal-content light px-5 py-4">
            <div class="d-flex mx-auto">
                <div class="content">
                    <h4 class="text-center">Please confirm details</h4>
                    <ul>
                        <li><span>Client Name</span>: {{apptDetails.parentDetails.studentFirstName}}
                            {{apptDetails.parentDetails.studentLastName}}</li>
                        <li><span>Assigned To</span>: {{assignedAdmin}}
                        </li>
                        <li><span>Location</span>: {{locationName}}</li>
                        <li><span>Follow Up Date</span>: {{assessmentDate}}</li>
                        <li><span>Follow Up Time</span>: {{appointmentTime}} </li>
                    </ul>
                    <hr/>
                    <div class="custom-control custom-checkbox text-center">
                        <input type="checkbox" [checked]="inPersonZoomFollowUp"
                            (change)="inPersonZoomFollowUp = !inPersonZoomFollowUp" class="custom-control-input">
                        <label class="custom-control-label">Online Follow Up (Zoom)</label>
                    </div>
                    <hr/>
                    <a (click)="CreateFollowUp()" class="theme-button mr-3" data-toggle="modal"
                       data-dismiss="modal">Confirm</a>
                    <a class="theme-button grey" data-dismiss="modal" data-toggle="modal"
                        data-target="#followUpModal">Change</a>
                </div>
            </div>
        </div>
    </div>
</div>



<ngx-spinner bdColor="rgba(51, 51, 51, 0.8)" size="default" type="ball-scale-multiple"></ngx-spinner>